import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { azul } from '../../assets/js/colors'

import { Btn, InputText } from '../../components'
import { hideLoadingBox, showLoadingBox, showMessageBox } from '../../store/actions/system.actions'

import '../Login/Login.css'
import useForgotPassword, { LOAD_MESSAGE } from './ForgotPasswordHook'

function ForgotPassword({ history, dispatch }) {
  const { state, localDispatch } = useForgotPassword()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.SEND_EMAIL:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.sendEmail(state.userCredentials.email)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox('Email enviado com sucesso', null))
        dispatch(hideLoadingBox())
        history.push('/')
        break

      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        localDispatch.resetState()
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div className="Login">
      <div className="form__container">
        <div style={{ textAlign: 'start', fontSize: '24px', color: azul }}>Redefinir senha</div>
        <div className="form">
          <div style={{ textAlign: 'start', marginTop: 15, color: azul }}>
            {' '}
            Enviaremos um email com instruções para redefinir sua senha.{' '}
          </div>
          <InputText
            label="Email"
            value={state.userCredentials.email}
            onChange={value => localDispatch.onChange('email', value)}
            onEnter={localDispatch.onRetrivePassword}
          />
          <div className="text-center" style={{ marginTop: 20 }}>
            <Btn onClick={localDispatch.onRetrivePassword} isLoading={state.isLoading}>
              Recuperar Senha
            </Btn>
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect()(ForgotPassword)
